/* eslint-disable jira/filename-case */
import difference from 'lodash/difference';
import type { AdminPagesFieldsColumnId } from './__generated__/useTableConfigColumnOrderQuery.graphql';

export const COLUMN_IDS_MAP = {
	NAME: 'NAME',
	TYPE: 'TYPE',
	DESCRIPTION: 'DESCRIPTION',
	CONTEXTS: 'CONTEXTS',
	SCREENS: 'SCREENS',
	PROJECTS: 'PROJECTS',
	CAN_BE_USED_IN: 'CAN_BE_USED_IN',
	LAST_USED: 'LAST_USED',
	PLANNED_DELETE_DATE: 'PLANNED_DELETE_DATE',
	TRASHED_DATE: 'TRASHED_DATE',
	FIELD_ID: 'FIELD_ID',
	ACTIONS: 'ACTIONS',
} as const;

export const COLUMN_IDS: readonly AdminPagesFieldsColumnId[] = Object.values(COLUMN_IDS_MAP);

export const SIDEBAR_IDS_MAP = {
	ADDSCHEMES: 'ADDSCHEMES',
	CREATE: 'CREATE',
	COLUMNS: 'COLUMNS',
	EDIT: 'EDIT',
	PROJECTS: 'PROJECTS',
	SCHEMES: 'SCHEMES',
	SCREENS: 'SCREENS',
} as const;

export const REORDERABLE_COLUMN_IDS = Object.freeze(
	new Set(difference(COLUMN_IDS, ['NAME', 'ACTIONS'])),
);

// Also in constants, but repeated here to avoid possible circular dependency
const PACKAGE_NAME = 'jiraAdminPagesFields';

// #region [client data DataIds]

export const ROOT_RECORD_ID = `client:${PACKAGE_NAME}:root`;
export const ACTIVE_TAB_ID = `client:${PACKAGE_NAME}:activeFieldsTab`;
export const DELETED_TAB_ID = `client:${PACKAGE_NAME}:deletedFieldsTab`;
export const CURRENT_SIDEBAR_ID = `client:${PACKAGE_NAME}:currentSidebar`;

// #endregion
